export default __webpack_public_path__ + "static/media/item2.912082c0.png";